import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { bem } from 'helpers/class-name';

const { element } = bem('input-field'); // also used in components/Form/PhoneNumber

const Textarea = forwardRef(({ hasError, heightInLines, className, ...props }, ref) => (
  <textarea
    ref={ref}
    {...props}
    className={element(
      'textarea',
      {
        hasError,
        [`height-in-lines-${heightInLines}`]: heightInLines,
      },
      className
    )}
  />
));

Textarea.propTypes = {
  hasError: PropTypes.bool,
  heightInLines: PropTypes.number,
  className: PropTypes.string,
};

export default Textarea;
